module.exports = __webpack_public_path__ + "static/media/videovalve.5e243e99.svg";